/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { createForm } from 'rc-form';
import classnames from 'classnames';
import { Grid, Typography, Fab, Card, CardContent, Button } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import { selectApplicationSettings } from 'Console/data/applicationDetail/settings/SettingsSelector';

import Search from 'Console/components/common/search/Search';
import Breadcrumb from 'Console/components/common/Breadcrumb';
import DrawerWrapper from 'Console/components/common/drawer/DrawerWrapper';
import EditTheme from 'Console/components/applications/detail/themes/EditTheme';
import ConfirmDialog from 'Console/components/common/confirmDialog/ConfirmDialog';

import { ROUTES } from 'Console/constants/routes';
import { selectThemeIdsData } from 'Console/data/applicationDetail/themes/selectors';
import {
    fetchThemesIds,
    cloneTheme,
    editTheme,
    deleteTheme,
    fetchThemeSchema,
} from 'Console/data/applicationDetail/themes/actions';

import BubblePreviewContainer from './BubblePreviewContainer';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
        alignItems: 'center',
        padding: '0 24px',
    },
    cssRoot: {
        '&:last-child': {
            paddingBottom: 0,
            paddingTop: 0,
        },
    },
    systemTheme: {
        backgroundColor: '#EEEEEE',
    },
    header: {
        paddingBottom: theme.typography.pxToRem(28),
    },
    searchBox: {
        paddingBottom: theme.typography.pxToRem(40),
    },
    searchInput: {
        width: theme.typography.pxToRem(192),
    },
    card: {
        width: '48%',
        marginBottom: '2%',
        boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
        borderRadius: theme.typography.pxToRem(6),
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    themeName: {
        paddingTop: theme.typography.pxToRem(20),
        paddingBottom: theme.typography.pxToRem(20),
    },
    buttonClone: {
        marginTop: theme.typography.pxToRem(10),
        marginBottom: theme.typography.pxToRem(10),
    },
    themeImage: {
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        paddingBottom: theme.typography.pxToRem(10),
    },
});

class ThemeContainer extends Component {
    state = {
        searchTherm: '',
        isDrawerWrapperShown: false,
        themeId: null,
        deleteDialogOpen: false,
    };

    componentDidMount() {
        const { match, fetchThemesIds } = this.props;
        if (match.params && match.params.appId) {
            fetchThemesIds(match.params.appId);
        }
    }

    handleChangeSearchTerm = (event) => {
        const { value } = event.target;
        this.setState({ searchTherm: value });
    };

    closeDrawerWrapper = () => {
        const {
            form: { resetFields },
        } = this.props;
        this.setState({ isDrawerWrapperShown: false, themeId: null });
        resetFields();
    };

    handeCloneTheme = (theme) => () => {
        const { cloneTheme, intl } = this.props;
        cloneTheme(theme, {
            success: `${intl.formatMessage({ id: 'Notification.theme.clone.success' })}`,
            fail: `${intl.formatMessage({ id: 'Notification.fail' })}`,
        });
    };

    handleSaveTheme = (themeId) => () => {
        const {
            editTheme,
            form: { getFieldsValue, resetFields },
            intl,
        } = this.props;
        const formValues = getFieldsValue([
            'name',
            'imageAddress',
            'fontFamily',
            'shadowDepth',
            'stepDepth',
            'backgroundPrimaryColor',
            'backgroundSecondaryColor',
            'fontColor',
            'titleColor',
            'navigationPrimaryColor',
            'navigationSecondaryColor',
            'shadowColor',
        ]);

        editTheme(themeId, formValues, {
            success: `${intl.formatMessage({ id: 'Notification.theme.edit.success' })}`,
            fail: `${intl.formatMessage({ id: 'Notification.fail' })}`,
        });
        this.closeDrawerWrapper();
        resetFields();
    };

    handleDeleteTheme = (themeId) => () => {
        this.setState({ deleteDialogOpen: false });
        const { deleteTheme, intl } = this.props;
        deleteTheme(themeId, {
            success: `${intl.formatMessage({ id: 'Notification.theme.delete.success' })}`,
            fail: `${intl.formatMessage({ id: 'Notification.fail' })}`,
        });
    };

    handleStartEditTheme = (themeId) => () => {
        this.setState({
            isDrawerWrapperShown: true,
            themeId,
        });
        const { fetchThemeSchema } = this.props;
        fetchThemeSchema(themeId);
    };

    render() {
        const {
            classes,
            intl,
            themeIds,
            applicationDetail: { data },
            match,
            form,
        } = this.props;
        const { searchTherm, themeId, isDrawerWrapperShown, deleteDialogOpen } = this.state;
        const { appId } = match.params;

        return (
            <>
                <Grid className={classes.root}>
                    <Grid>
                        <DrawerWrapper
                            title={intl.formatMessage({ id: 'Themes.edit.title' })}
                            name={intl.formatMessage({ id: 'Buttons.cancel' })}
                            term={intl.formatMessage({ id: 'Buttons.apply' })}
                            isShown={isDrawerWrapperShown}
                            onClose={this.closeDrawerWrapper}
                            onConfirm={this.handleSaveTheme(this.state.themeId)}
                        >
                            <EditTheme editThemeId={themeId} form={form} />
                        </DrawerWrapper>
                    </Grid>
                    <Grid item xs={12}>
                        <Breadcrumb
                            paths={[
                                {
                                    to: ROUTES.APPLICATIONS,
                                    text: intl.formatMessage({ id: 'Navigation.applications' }),
                                },
                                {
                                    text: data.name,
                                },
                            ]}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <Grid container alignItems="flex-end">
                            <Grid
                                className={classes.header}
                                container
                                justify="space-between"
                                alignItems="flex-end"
                            >
                                <Grid item>
                                    <Typography variant="h6">
                                        {intl.formatMessage({
                                            id: 'Themes.title',
                                        })}
                                    </Typography>
                                </Grid>
                            </Grid>

                            <Grid container justify="flex-start" className={classes.searchBox}>
                                <Grid className={classes.searchInput}>
                                    <Search
                                        id="form-item-search"
                                        placeholder={intl.formatMessage({
                                            id: 'Themes.search.placeholder',
                                        })}
                                        onChange={this.handleChangeSearchTerm}
                                    />
                                </Grid>
                                <Fab
                                    color="primary"
                                    aria-label="Search"
                                    style={{ marginLeft: '0.9375rem' }}
                                >
                                    <SearchIcon />
                                </Fab>
                            </Grid>
                        </Grid>
                    </Grid>

                    {themeIds.length > 0 && (
                        <Grid item>
                            <Grid
                                id="yeself-themes-wrapper"
                                container
                                direction="row"
                                justify="space-between"
                            >
                                {themeIds
                                    .filter(
                                        (theme) =>
                                            theme.name.toLowerCase().indexOf(searchTherm.toLowerCase()) >
                                            -1
                                    )
                                    .map((theme) => (
                                        <Card
                                            className={classnames(classes.card, {
                                                [classes.systemTheme]: theme.kind === 'system',
                                            })}
                                            key={theme.id}
                                        >
                                            <CardContent
                                                classes={{
                                                    root: classes.cssRoot,
                                                }}
                                            >
                                                <Grid container direction="row" justify="center">
                                                    <Typography className={classes.themeName} variant="h6">
                                                        {theme.name}
                                                    </Typography>
                                                </Grid>

                                                <Grid item className={classes.themeImage}>
                                                    <BubblePreviewContainer
                                                        key={theme.id}
                                                        themeId={theme.id}
                                                        appId={appId}
                                                    />
                                                </Grid>

                                                {!theme.isAdministrable && (
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justify="flex-end"
                                                        alignItems="center"
                                                        className={classes.buttonClone}
                                                    >
                                                        <Typography>
                                                            <Button
                                                                id="yeself-button"
                                                                color="primary"
                                                                onClick={this.handeCloneTheme(theme)}
                                                            >
                                                                {intl.formatMessage({
                                                                    id: 'Buttons.clone',
                                                                })}
                                                            </Button>
                                                        </Typography>
                                                    </Grid>
                                                )}

                                                {theme.isAdministrable && (
                                                    <Grid
                                                        container
                                                        direction="row"
                                                        justify="flex-end"
                                                        alignItems="center"
                                                        className={classes.buttonClone}
                                                    >
                                                        <Typography>
                                                            <Button
                                                                id="yeself-button"
                                                                color="secondary"
                                                                onClick={() =>
                                                                    this.setState({
                                                                        deleteDialogOpen: true,
                                                                        themeId: theme.id,
                                                                    })
                                                                }
                                                            >
                                                                {intl.formatMessage({
                                                                    id: 'Buttons.delete',
                                                                })}
                                                            </Button>
                                                        </Typography>
                                                        <Typography>
                                                            <Button
                                                                id="yeself-button"
                                                                color="primary"
                                                                onClick={this.handleStartEditTheme(
                                                                    theme.id
                                                                )}
                                                            >
                                                                {intl.formatMessage({
                                                                    id: 'Buttons.edit',
                                                                })}
                                                            </Button>
                                                        </Typography>
                                                    </Grid>
                                                )}
                                            </CardContent>
                                        </Card>
                                    ))}
                            </Grid>
                        </Grid>
                    )}
                </Grid>

                <ConfirmDialog
                    title={intl.formatMessage({ id: 'Theme.delete.message' })}
                    open={deleteDialogOpen}
                    content=""
                    closeAction={() => this.setState({ deleteDialogOpen: false })}
                    action={this.handleDeleteTheme(this.state.themeId)}
                    agreeLabel={intl.formatMessage({ id: 'Buttons.delete' })}
                    disagreeLabel={intl.formatMessage({ id: 'Buttons.cancel' })}
                />
            </>
        );
    }
}

export default connect(
    (state) => ({
        themeIds: selectThemeIdsData(state),
        applicationDetail: selectApplicationSettings(state),
    }),
    {
        fetchThemesIds,
        cloneTheme,
        editTheme,
        deleteTheme,
        fetchThemeSchema,
    }
)(withStyles(styles)(injectIntl(createForm()(ThemeContainer))));
